module.exports = __webpack_public_path__ + "static/media/image_88.e19be131.png";